/** Generationen skifter, når en ny autentificeret browsersession etableres. */
let authenticationGeneration = 0;

export const API_UNAUTHORIZED_EVENT = "appsmeden:api-unauthorized";
export const SHELL_SESSION_EXPIRED_EVENT = "appsmeden:shell-session-expired";

export interface UnauthorizedEventDetail {
  generation: number;
}

export function currentAuthenticationGeneration(): number {
  return authenticationGeneration;
}

export function advanceAuthenticationGeneration(): void {
  authenticationGeneration += 1;
}

export function unauthorizedGeneration(event: Event): number | null {
  if (!(event instanceof CustomEvent)) return null;
  const detail = event.detail as Partial<UnauthorizedEventDetail> | null;
  return typeof detail?.generation === "number" ? detail.generation : null;
}
